import { FC } from 'react';
import ScanPageBody from './body';
import ScanPageLeft, { IScanPageLeftComponent} from './left';
import BodyContent, { IScanPageContentComponent} from './content';
import BodyRight, { IScanPageRightComponent } from './right';
import {
  ScanPageBodyProps,
} from '../interface';

export type IScanPageBodyComponent = FC<ScanPageBodyProps> & {
  Left: IScanPageLeftComponent;
  Content: IScanPageContentComponent;
  Right: IScanPageRightComponent;
};

const TransScanPageBody = ScanPageBody as IScanPageBodyComponent;
TransScanPageBody.Left = ScanPageLeft;
TransScanPageBody.Content = BodyContent;
TransScanPageBody.Right = BodyRight;

export default TransScanPageBody;